// extracted by mini-css-extract-plugin
export var container = "OfferBlock-module--container--TPFv3";
export var titleBlockContainer = "OfferBlock-module--titleBlockContainer--6LsXt";
export var title = "OfferBlock-module--title--37nbE";
export var titleExplanation = "OfferBlock-module--titleExplanation--aXV3Y";
export var button = "OfferBlock-module--button--uBpjo";
export var contentTitle = "OfferBlock-module--contentTitle--Wfkxf";
export var content = "OfferBlock-module--content--SsgbY";
export var isVisibleContent = "OfferBlock-module--isVisibleContent--7Qb70";